<template>
  <v-container fluid>
    <v-row dense class="mb-3">
      <v-col cols="12" class="d-flex flex-wrap align-end">
        <datePicker v-model="filtro.desde" format="YYYY-MM-DD" label="Desde (Obligatorio)" maxToday clearable />
        <datePicker v-model="filtro.hasta" format="YYYY-MM-DD" label="Hasta (Obligatorio)" maxToday clearable
          class="ml-3" />
        <v-autocomplete v-model="filtro.area" label="Area" :items="areas" item-value="idArea" item-text="nombre" />
        <v-btn color="primary" class="mt-0" :disabled="!filtrosValidos || loading" @click="loadData">
          <v-icon left small>mdi-magnify</v-icon> Buscar
        </v-btn>
      </v-col>
    </v-row>

    <v-row dense>
      <v-col cols="12" md="6">
        <v-card outlined class="pa-3 text-center">
          <div class="text-caption grey--text">Tiempo total de respuesta de atención a paro</div>
          <div class="text-h4 font-weight-bold">{{ kpiSumHms }}</div>
        </v-card>
      </v-col>
      <v-col cols="12" md="6">
        <v-card outlined class="pa-3 text-center">
          <div class="text-caption grey--text">Tiempo promedio de atención a paros</div>
          <div class="text-h4 font-weight-bold">{{ kpiPromHms }}</div>
        </v-card>
      </v-col>
    </v-row>

    <v-row dense class="mt-4">
      <v-col cols="12" md="6">
        <v-card outlined class="pa-3">
          <div class="d-flex align-center mb-2">
            <span class="text-subtitle-2">
              Promedio diario del tiempo de respuesta (minutos por ticket)
            </span>
            <v-tooltip v-if="false" bottom open-on-hover :open-delay="100">
              <template v-slot:activator="{ on, attrs }">
                <v-icon small class="ml-1" color="grey darken-1" v-bind="attrs"
                  v-on="on">mdi-help-circle-outline</v-icon>
              </template>
              <div style="max-width:260px; white-space:normal; line-height:1.2;">
                Para cada día del rango, se promedia <b>TiempoRespuesta_Min</b> de los tickets de ese día.
              </div>
            </v-tooltip>
          </div>
          <apexchart :key="chartKey.line" type="line" height="240" :options="opts.line" :series="series.historial" />
        </v-card>
      </v-col>

      <v-col cols="12" md="6">
        <v-card outlined class="pa-3">
          <div class="d-flex align-center mb-2">
            <span class="text-subtitle-2">Tiempo de respuesta por área — Promedio (h:m:s por ticket)</span>
            <v-tooltip v-if="false" bottom open-on-hover :open-delay="100">
              <template v-slot:activator="{ on, attrs }">
                <v-icon small class="ml-1" color="grey darken-1" v-bind="attrs"
                  v-on="on">mdi-help-circle-outline</v-icon>
              </template>
              <div style="max-width:260px; white-space:normal; line-height:1.2;">
                Promedio de <b>TiempoRespuesta_Min</b> por ticket en cada área dentro del periodo seleccionado.
              </div>
            </v-tooltip>
          </div>
          <apexchart :key="chartKey.areas" type="bar" height="240" :options="opts.areas" :series="series.areasProm" />
        </v-card>
      </v-col>
    </v-row>

    <v-row dense class="mt-4">
      <v-col cols="12" md="6">
        <v-card outlined class="pa-3">
          <div class="d-flex align-center mb-2">
            <span class="text-subtitle-2">
              Ranking de máquinas por tiempo de respuesta promedio (h:m:s por ticket) — de mayor a menor
            </span>
            <v-tooltip v-if="false" bottom open-on-hover :open-delay="100">
              <template v-slot:activator="{ on, attrs }">
                <v-icon small class="ml-1" color="grey darken-1" v-bind="attrs"
                  v-on="on">mdi-help-circle-outline</v-icon>
              </template>
              <div style="max-width:260px; white-space:normal; line-height:1.2;">
                Se ordena por el promedio de <b>TiempoRespuesta_Min</b>. Las primeras barras son las más lentas.
              </div>
            </v-tooltip>
          </div>
          <apexchart :key="chartKey.maq" type="bar" height="260" :options="opts.maq" :series="series.maquinas" />
        </v-card>
      </v-col>

      <v-col cols="12" md="6">
        <v-card outlined class="pa-3">
          <div class="d-flex align-center mb-2">
            <span class="text-subtitle-2">Tiempo de respuesta promedio por rol (h:m:s por ticket)</span>
            <v-tooltip v-if="false" bottom open-on-hover :open-delay="100">
              <template v-slot:activator="{ on, attrs }">
                <v-icon small class="ml-1" color="grey darken-1" v-bind="attrs"
                  v-on="on">mdi-help-circle-outline</v-icon>
              </template>
              <div style="max-width:260px; white-space:normal; line-height:1.2;">
                Promedio de <b>TiempoRespuesta_Min</b> de los tickets atendidos por cada rol.
              </div>
            </v-tooltip>
          </div>
          <apexchart :key="chartKey.roles" type="bar" height="260" :options="opts.roles" :series="series.roles" />
        </v-card>
      </v-col>
    </v-row>

    <v-row dense class="mt-4">
      <v-col cols="12" md="6">
        <v-card outlined class="pa-3">
          <div class="d-flex align-center mb-2">
            <span class="text-subtitle-2">Tiempo acumulado de respuesta por área (h:m:s)</span>
            <v-tooltip v-if="false" bottom open-on-hover :open-delay="100">
              <template v-slot:activator="{ on, attrs }">
                <v-icon small class="ml-1" color="grey darken-1" v-bind="attrs" v-on="on">
                  mdi-help-circle-outline
                </v-icon>
              </template>
              <div style="max-width:260px; white-space:normal; line-height:1.2;">
                Total de <b>TiempoRespuesta_Min</b> acumulado por área, considerando todos los tickets.
              </div>
            </v-tooltip>
          </div>
          <apexchart :key="chartKey.areasTot" type="bar" height="260" :options="opts.areasTot"
            :series="series.areasTot" />
        </v-card>
      </v-col>

      <v-col cols="12" md="6">
        <v-card outlined class="pa-3">
          <div class="d-flex align-center mb-2">
            <span class="text-subtitle-2">Tiempo acumulado de respuesta por máquina (h:m:s)</span>
            <v-tooltip v-if="false" bottom open-on-hover :open-delay="100">
              <template v-slot:activator="{ on, attrs }">
                <v-icon small class="ml-1" color="grey darken-1" v-bind="attrs" v-on="on">
                  mdi-help-circle-outline
                </v-icon>
              </template>
              <div style="max-width:260px; white-space:normal; line-height:1.2;">
                Total de <b>TiempoRespuesta_Min</b> acumulado por máquina, considerando todos los tickets.
              </div>
            </v-tooltip>
          </div>
          <apexchart :key="chartKey.maqTot" type="bar"  :options="opts.maqTot" :height="series.maqTot.length > 5 ? opts.maqTot.chart.height : 260" :series="series.maqTot" />
        </v-card>
      </v-col>
    </v-row>

    <v-row dense class="mt-4">
      <v-col cols="12" md="6">
        <v-card outlined class="pa-3">
          <div class="d-flex align-center mb-2">
            <span class="text-subtitle-2">Tiempo de respuesta promedio por persona (h:m:s por ticket)</span>
            <v-tooltip v-if="false" bottom open-on-hover :open-delay="100">
              <template v-slot:activator="{ on, attrs }">
                <v-icon small class="ml-1" color="grey darken-1" v-bind="attrs" v-on="on">
                  mdi-help-circle-outline
                </v-icon>
              </template>
              <div style="max-width:260px; white-space:normal; line-height:1.2;">
                Promedio de <b>TiempoRespuesta_Min</b> por persona que respondió tickets.
              </div>
            </v-tooltip>
          </div>
          <apexchart :key="chartKey.personasProm" type="bar" height="260" :options="opts.personasProm"
            :series="series.personasProm" />
        </v-card>
      </v-col>

      <v-col cols="12" md="6">
        <v-card outlined class="pa-3">
          <div class="d-flex align-center mb-2">
            <span class="text-subtitle-2">Tiempo de respuesta total por persona (h:m:s)</span>
            <v-tooltip v-if="false" bottom open-on-hover :open-delay="100">
              <template v-slot:activator="{ on, attrs }">
                <v-icon small class="ml-1" color="grey darken-1" v-bind="attrs" v-on="on">
                  mdi-help-circle-outline
                </v-icon>
              </template>
              <div style="max-width:260px; white-space:normal; line-height:1.2;">
                Total acumulado de <b>TiempoRespuesta_Min</b> por persona que respondió alertas.
              </div>
            </v-tooltip>
          </div>
          <apexchart :key="chartKey.personasTot" type="bar" height="260" :options="opts.personasTot"
            :series="series.personasTot" />
        </v-card>
      </v-col>
    </v-row>

    <v-row dense class="mt-4">
      <v-col cols="12">
        <v-card outlined>
          <v-toolbar flat dense>
            <v-toolbar-title class="subtitle-2">Detalle de tickets (un renglón por ticket)</v-toolbar-title>
            <v-spacer />
            <v-text-field v-if="false" v-model="q" dense solo-inverted flat hide-details
              prepend-inner-icon="mdi-magnify" label="Buscar en fecha, área, máquina o rol" />
          </v-toolbar>

          <v-data-table :headers="headers" :items="rowsFiltradas" :loading="loading" class="elevation-0" dense
            :sort-by="['tar_min']" :sort-desc="[true]" must-sort>
            <template v-slot:item.tar_min="{ item }">
              {{ fmtHms(item.tar_min) }}
            </template>
          </v-data-table>
        </v-card>
      </v-col>
    </v-row>

    <v-row v-if="!loading && vacio" class="mt-6">
      <v-col cols="12" class="text-center grey--text">
        No hay datos para el rango y filtros seleccionados. Ajusta las fechas o quita filtros.
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import axios from "axios";
import VueApexCharts from "vue-apexcharts";

const EP = "/Reportes/ReporteTiempoRespuestaMantenimiento";
const pick = (o, ...keys) => { for (const k of keys) { if (o && Object.prototype.hasOwnProperty.call(o, k)) return o[k]; } };
const num = (v) => (v === null || v === undefined || v === "" ? null : Number(v));

export default {
  name: "DashboardTiempoRespuesta",
  components: { apexchart: VueApexCharts },
  data() {
    return {
      loading: false,
      q: "",
      filtro: { desde: null, hasta: null, rol: null, area: null, maquina: null },

      kpiPromMin: 0,
      kpiSumMin: 0,

      chartKey: {
        line: 0, areas: 0, maq: 0, roles: 0, areasTot: 0, maqTot: 0, personasProm: 0,
        personasTot: 0
      },

      series: {
        historial: [{ name: "Promedio", data: [] }],
        areasProm: [{ name: "Promedio", data: [] }],
        maquinas: [{ name: "Promedio", data: [] }],
        roles: [{ name: "Promedio", data: [] }],
        areasTot: [{ name: "Total", data: [] }],
        maqTot: [{ name: "Total", data: [] }],
        personasProm: [{ name: "Promedio", data: [] }],
        personasTot: [{ name: "Total", data: [] }]
      },

      opts: {
        line: {
          chart: { toolbar: { show: false } },
          stroke: { curve: "smooth" },
          dataLabels: { enabled: false },
          xaxis: { categories: [], title: { text: "Día" } },
          yaxis: { min: 0, title: { text: "Minutos por ticket" } },
          tooltip: { y: { formatter: v => this.fmtHms(v) } }
        },
        areas: {
          chart: { toolbar: { show: false } },
          plotOptions: { bar: { columnWidth: "55%" } },
          dataLabels: { enabled: true, formatter: v => this.fmtHms(v) },
          xaxis: { categories: [], title: { text: "Área" } },
          yaxis: { min: 0, title: { text: "Minutos por ticket" } },
          tooltip: { y: { formatter: v => this.fmtHms(v) } }
        },
        maq: {
          chart: { toolbar: { show: false } },
          plotOptions: { bar: { horizontal: true, barHeight: "60%" } },
          dataLabels: { enabled: true, formatter: v => this.fmtHms(v) },
          xaxis: { categories: [], title: { text: "Minutos por ticket" } },
          yaxis: { title: { text: "Máquina" } },
          tooltip: { y: { formatter: v => this.fmtHms(v) } }
        },
        roles: {
          chart: { toolbar: { show: false } },
          plotOptions: { bar: { columnWidth: "55%" } },
          dataLabels: { enabled: true, formatter: v => this.fmtHms(v) },
          xaxis: { categories: [], title: { text: "Rol" } },
          yaxis: { min: 0, title: { text: "Minutos por ticket" } },
          tooltip: { y: { formatter: v => this.fmtHms(v) } }
        },
        areasTot: {
          chart: { toolbar: { show: false } },
          plotOptions: { bar: { columnWidth: "55%" } },
          dataLabels: { enabled: true, formatter: v => this.fmtHms(v) },
          xaxis: { categories: [], title: { text: "Área" } },
          yaxis: { min: 0, title: { text: "Minutos acumulados" } },
          tooltip: { y: { formatter: v => this.fmtHms(v) } }
        },
        maqTot: {
          chart: { toolbar: { show: false } },
          plotOptions: { bar: { horizontal: true, barHeight: "60%" } },
          dataLabels: { enabled: true, formatter: v => this.fmtHms(v) },
          xaxis: { categories: [], title: { text: "Minutos acumulados" } },
          yaxis: { title: { text: "Máquina" } },
          tooltip: { y: { formatter: v => this.fmtHms(v) } }
        },
        personasProm: {
          chart: { toolbar: { show: false } },
          plotOptions: { bar: { horizontal: true, barHeight: "60%" } },
          dataLabels: { enabled: true, formatter: v => this.fmtHms(v) },
          xaxis: { categories: [], title: { text: "Minutos por ticket" } },
          yaxis: { title: { text: "Persona" } },
          tooltip: { y: { formatter: v => this.fmtHms(v) } }
        },
        personasTot: {
          chart: { toolbar: { show: false } },
          plotOptions: { bar: { horizontal: true, barHeight: "60%" } },
          dataLabels: { enabled: true, formatter: v => this.fmtHms(v) },
          xaxis: { categories: [], title: { text: "Minutos acumulados" } },
          yaxis: { title: { text: "Persona" } },
          tooltip: { y: { formatter: v => this.fmtHms(v) } }
        }
      },

      headers: [
        { text: "Fecha", value: "fecha", sortable: true },
        { text: "Área", value: "area" },
        { text: "Máquina", value: "maquina" },
        { text: "Rol", value: "rol" },
        { text: "Tiempo de respuesta (h:m:s)", value: "tar_min", align: "end" }
      ],
      rows: [],
      areas: [],
    };
  },
  computed: {
    filtrosValidos() {
      if (!this.filtro.desde || !this.filtro.hasta) return false;
      return new Date(this.filtro.hasta) >= new Date(this.filtro.desde);
    },
    rowsFiltradas() {
      const q = this.q?.toLowerCase() || "";
      const filtered = !q
        ? this.rows
        : this.rows.filter(r =>
          String(r.fecha).toLowerCase().includes(q) ||
          String(r.area).toLowerCase().includes(q) ||
          String(r.maquina).toLowerCase().includes(q) ||
          String(r.rol).toLowerCase().includes(q)
        );
      return filtered.slice().sort((a, b) => (b.tar_min ?? -Infinity) - (a.tar_min ?? -Infinity));
    },
    vacio() {
      return !this.rows.length &&
        !this.series.historial[0].data.length &&
        !this.series.areasProm[0].data.length &&
        !this.series.maquinas[0].data.length &&
        !this.series.roles[0].data.length;
    },

    kpiPromHms() { return this.fmtHms(this.kpiPromMin); },
    kpiSumHms() { return this.fmtHms(this.kpiSumMin); }
  },
  methods: {
    async loadData() {
      this.loading = true;
      try {
        const params = {
          desde: this.filtro.desde,
          hasta: this.filtro.hasta
        };
        if (this.filtro.rol) params.idsRoles = [this.filtro.rol];
        if (this.filtro.area) params.idsAreas = [this.filtro.area];
        if (this.filtro.maquina) params.idsMaquinas = [this.filtro.maquina];


        const { data } = await axios.get(EP, {
          params,
          paramsSerializer: p => new URLSearchParams(p).toString()
        });


        const K = pick(data, "kpis", "Kpis") || {};
        const H = pick(data, "historial", "Historial") || [];
        const A = pick(data, "porArea", "PorArea") || [];
        const R = pick(data, "porRol", "PorRol") || [];
        const M = pick(data, "porMaquina", "PorMaquina") || [];
        const D = pick(data, "detalle", "Detalle") || [];
        const P = pick(data, "porPersona", "PorPersona") || [];

        const kProm = num(pick(K, "promedio_Min", "Promedio_Min", "promedio_min")) || 0;
        let kTotMin = num(pick(K, "total_Min", "Total_Min", "total_min"));
        if (kTotMin == null) {
          const totalHoras = num(pick(K, "total_Horas", "Total_Horas", "total_horas"));
          if (totalHoras != null) kTotMin = totalHoras * 60;
        }
        if (kTotMin == null && Array.isArray(D)) {
          kTotMin = D.reduce((acc, d) => {
            const v = num(pick(d, "tiempoRespuesta_Min", "TiempoRespuesta_Min", "tiempo_respuesta_min"));
            return acc + (v || 0);
          }, 0);
        }
        this.kpiPromMin = kProm;
        this.kpiSumMin = kTotMin || 0;

        const hCats = H.map(d => pick(d, "fecha", "Fecha")).filter(Boolean);
        const hVals = H.map(d => num(pick(d, "promedio_Min", "Promedio_Min", "promedio_min")) ?? 0);
        this.opts.line.xaxis.categories = hCats;
        this.series.historial = [{ name: "Promedio", data: hVals }];
        this.chartKey.line++;

        const areasSorted = A.map(a => ({
          label: pick(a, "area", "Area"),
          prom: num(pick(a, "promedio_Min", "Promedio_Min", "promedio_min")) ?? 0,
          total: num(pick(a, "total_Min", "Total_Min", "total_min")) ?? 0
        })).filter(x => !!x.label);

        const areasProm = [...areasSorted].sort((a, b) => b.prom - a.prom);
        const areasTot = [...areasSorted].sort((a, b) => b.total - a.total);

        this.opts.areas.xaxis.categories = areasProm.map(x => x.label);
        this.series.areasProm = [{ name: "Promedio", data: areasProm.map(x => x.prom) }];
        this.chartKey.areas++;

        this.opts.areasTot.xaxis.categories = areasTot.map(x => x.label);
        this.series.areasTot = [{ name: "Total", data: areasTot.map(x => x.total) }];
        this.chartKey.areasTot++;

        const maqSorted = M.map(m => ({
          label: pick(m, "maquina", "Maquina"),
          prom: num(pick(m, "promedio_Min", "Promedio_Min", "promedio_min")) ?? 0,
          total: num(pick(m, "total_Min", "Total_Min", "total_min")) ?? 0
        })).filter(x => !!x.label);

        const maqProm = [...maqSorted].sort((a, b) => b.prom - a.prom);
        const maqTot = [...maqSorted].sort((a, b) => b.total - a.total);
        window.maqTotLabels = maqTot.map(x => x.label);

        this.opts.maq.xaxis.categories = maqProm.map(x => x.label);
        this.series.maquinas = [{ name: "Promedio", data: maqProm.map(x => x.prom) }];
        this.chartKey.maq++;

        // this.opts.maqTot.yaxis.categories = maqTot.map(x => x.label);
        this.opts.maqTot = {
          chart: {
            height: maqTot.length * 25,
            toolbar: { show: false }
          },
          plotOptions: {
            bar: {
              horizontal: true,
              barHeight: "60%"
            }
          },
          dataLabels: { enabled: true },
          xaxis: {
            title: { text: "Minutos acumulados" },
            // ⚠️ NO pongas categories aquí
            categories: maqTot.map(x => x.label),

          },
          yaxis: {
            title: { text: "Máquina" },
            // categories: maqTot.map(x => x.label),
            labels: {
              show: true,
              style: { fontSize: "12px" }
            }
          },
          tooltip: { y: {} }
        };
        this.series.maqTot = [{ name: "Total", data: maqTot.map(x => x.total) }];
        this.chartKey.maqTot++;

        const rSorted = R.map(r => ({
          label: pick(r, "rol", "Rol"),
          value: num(pick(r, "promedio_Min", "Promedio_Min", "promedio_min")) ?? 0
        })).filter(x => !!x.label).sort((a, b) => b.value - a.value);

        this.opts.roles.xaxis.categories = rSorted.map(x => x.label);
        this.series.roles = [{ name: "Promedio", data: rSorted.map(x => x.value) }];
        this.chartKey.roles++;
        const personasSorted = P.map(p => ({
          label: pick(p, "persona", "Persona"),
          prom: num(pick(p, "promedio_Min", "Promedio_Min", "promedio_min")) ?? 0,
          total: num(pick(p, "total_Min", "Total_Min", "total_min")) ?? 0
        })).filter(x => !!x.label);

        const personasProm = [...personasSorted].sort((a, b) => b.prom - a.prom);
        const personasTot = [...personasSorted].sort((a, b) => b.total - a.total);

        this.opts.personasProm.xaxis.categories = personasProm.map(x => x.label);
        this.series.personasProm = [{ name: "Promedio", data: personasProm.map(x => x.prom) }];
        this.chartKey.personasProm++;

        this.opts.personasTot.xaxis.categories = personasTot.map(x => x.label);
        this.series.personasTot = [{ name: "Total", data: personasTot.map(x => x.total) }];
        this.chartKey.personasTot++;


        this.rows = (D || []).map(d => ({
          fecha: pick(d, "fecha", "Fecha"),
          area: pick(d, "area", "Area"),
          maquina: pick(d, "maquina", "Maquina"),
          rol: pick(d, "rol", "Rol"),
          tar_min: num(pick(d, "tiempoRespuesta_Min", "TiempoRespuesta_Min", "tiempo_respuesta_min"))
        })).filter(r => r.fecha);
      } finally {
        this.loading = false;
      }
    },
    fmtHms(mins) {
      if (mins === null || mins === undefined || Number.isNaN(mins)) return "0 s";
      const total = Math.round(Number(mins) * 60);
      const h = Math.floor(total / 3600);
      const m = Math.floor((total % 3600) / 60);
      const s = total % 60;
      if (h > 0) return `${h} h ${m} min ${s} s`;
      if (m > 0) return `${m} min ${s} s`;
      return `${s} s`;
    },
    getAreas() {
      axios
        .get("/Areas")
        .then(response => this.areas = response.data)
        .catch(error => console.log(error))
    }
  },
  mounted() {
    this.getAreas();
  }
};
</script>


<style scoped>
.v-card {
  border-radius: 12px;
}
</style>
